import { useContext } from "react";
import { buildClasses } from "../utils/buildClasses";
import { TransactionColumnHeaderAccount } from "./TransactionColumnHeaderAccount";
import { TransactionColumnHeaderType } from "./TransactionColumnHeaderType";
import { TransactionColumnHeaderMerchant } from "./TransactionColumnHeaderMerchant";
import { TransactionColumnHeaderDescription } from "./TransactionColumnHeaderDescription";
import { TransactionColumnHeaderCategory } from "./TransactionColumnHeaderCategory";
import { TransactionColumnHeaderRule } from "./TransactionColumnHeaderRule";
import { TransactionColumnHeaderAmount } from "./TransactionColumnHeaderAmount";
import { TransactionColumnHeaderDate } from "./TransactionColumnHeaderDate";
import { TransactionColumnHeaderReviewed } from "./TransactionColumnHeaderReviewed";
import { TransactionColumnHeaderTags } from "./TransactionColumnHeaderTags";
import { TransactionColumnSpacer } from "./TransactionColumnSpacer";
import { TransactionsNavContext } from "./TransactionsScreen";
import { TransactionColumn } from "./TransactionColumn";

/** The row of column headers; see TransactionsColumnHeaders for placing it. */
export function TransactionsHeader(): JSX.Element {
  const [transactionsNav] = useContext(TransactionsNavContext);
  const { columnSettings } = transactionsNav;

  return (
    <div
      className={buildClasses(
        "h-10",
        "flex",
        "items-center",
        "justify-center",
        "py-1",
        "font-medium",
      )}
    >
      {columnSettings[TransactionColumn.DATE].shown && (
        <>
          <TransactionColumnHeaderDate />
          <TransactionColumnSpacer />
        </>
      )}
      {columnSettings[TransactionColumn.ACCOUNT].shown && (
        <>
          <TransactionColumnHeaderAccount />
          <TransactionColumnSpacer />
        </>
      )}
      {columnSettings[TransactionColumn.TYPE].shown && (
        <>
          <TransactionColumnHeaderType />
          <TransactionColumnSpacer />
        </>
      )}
      {columnSettings[TransactionColumn.MERCHANT].shown && (
        <>
          <TransactionColumnHeaderMerchant />
          <TransactionColumnSpacer />
        </>
      )}
      {columnSettings[TransactionColumn.DESCRIPTION].shown && (
        <>
          <TransactionColumnHeaderDescription />
          <TransactionColumnSpacer />
        </>
      )}
      {columnSettings[TransactionColumn.CATEGORY].shown && (
        <>
          <TransactionColumnHeaderCategory />
          <TransactionColumnSpacer />
        </>
      )}
      {columnSettings[TransactionColumn.TAGS].shown && (
        <>
          <TransactionColumnHeaderTags />
          <TransactionColumnSpacer />
        </>
      )}
      {columnSettings[TransactionColumn.RULE].shown && (
        <>
          <TransactionColumnHeaderRule />
          <TransactionColumnSpacer />
        </>
      )}
      {columnSettings[TransactionColumn.REVIEWED].shown && (
        <>
          <TransactionColumnHeaderReviewed />
          <TransactionColumnSpacer />
        </>
      )}
      {columnSettings[TransactionColumn.AMOUNT].shown && (
        <TransactionColumnHeaderAmount />
      )}
    </div>
  );
}
